import { downloadAxios } from '@/plugins/axios'
import format from 'string-format'

const baseUrl = '/v1/file'

const exportPdfLink = `${baseUrl}/export/pdf/{orderId}`

export const exportPdf = (orderId, params) =>
  downloadAxios.get(format(exportPdfLink, { orderId }), {
    params,
    responseType: 'blob',
  })
